import { AppDispatch } from 'store'
import { companyApi } from 'store/company/company.api'
import { Company } from 'store/company/company.types'
import { CompanyEmail, CompanyPhone } from 'store/company/company.types'
import {
  findDispatchEmail,
  findDispatchPhone,
  formatCompanyAddress,
} from 'pages/address/address-details/carrier-details/carrier-contact.utils'
import { formatPhoneForDisplay } from 'utils/phone'

export type CarrierContactDetails = {
  carrierAddress?: string
  dispatchName?: string
  dispatchEmail?: string
  dispatchPhone?: string
  dispatchCell?: string
  dispatchAfterHours?: string
}

export function mapCompanyToCarrierContact(
  company: Company,
  emails: CompanyEmail[],
  phones: CompanyPhone[]
): CarrierContactDetails {
  return {
    carrierAddress: formatCompanyAddress(company),
    dispatchEmail: findDispatchEmail(emails)?.email ?? '',
    dispatchPhone: formatPhoneForDisplay(findDispatchPhone(phones, 'Dispatch')?.phone),
    dispatchCell: formatPhoneForDisplay(findDispatchPhone(phones, 'DispatchCell')?.phone),
    dispatchAfterHours: formatPhoneForDisplay(
      findDispatchPhone(phones, 'DispatchAfterHoursPhone')?.phone
    ),
  }
}

export async function fetchCarrierContactDetails(
  dispatch: AppDispatch,
  companyId: string
): Promise<CarrierContactDetails | null> {
  if (!companyId.trim()) return null

  try {
    const [companyResult, emailsResult, phonesResult] = await Promise.all([
      dispatch(companyApi.endpoints.getCompanyById.initiate({ id: companyId })),
      dispatch(companyApi.endpoints.getCompanyEmails.initiate({ companyId })),
      dispatch(companyApi.endpoints.getCompanyPhones.initiate({ companyId })),
    ])

    if (!companyResult.data) return null

    return mapCompanyToCarrierContact(
      companyResult.data,
      emailsResult.data ?? [],
      phonesResult.data ?? []
    )
  } catch {
    return null
  }
}
